// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  Toolbar,
  BooleanField,
  BooleanInput,
  Pagination,
} from "react-admin";

const UsersFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Rechercher par Id" source="id" alwaysOn />
    <TextInput label="Rechercher par prénom" source="firstName" alwaysOn />
    <TextInput label="Rechercher par nom" source="lastName" alwaysOn />
    <TextInput label="Rechercher par phone" source="phone" />
    <TextInput label="Rechercher par email" source="email" />
    <BooleanInput label="Est un Pro" source="isPro" />
    <BooleanInput label="Est un Admin" source="isAdmin" />
  </Filter>
);

const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

export const UsersList = (props) => (
  <List {...props} filters={<UsersFilter />} pagination={<PostPagination />}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="firstName" />
      <TextField source="lastName" />
      <TextField source="phone" />
      <TextField source="email" />
      <BooleanField source="isPro" />
      <BooleanField source="isAdmin" />
      <ShowButton label="" />
      <EditButton label="" />
      <DeleteButton label="" redirect={false} />
    </Datagrid>
  </List>
);

export const UsersShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="firstName" />
      <TextField source="lastName" />
      <TextField source="phone" />
      <TextField source="email" />
      <BooleanField source="isPro" />
      <BooleanField source="isAdmin" />
    </SimpleShowLayout>
  </Show>
);

export const UsersEdit = (props) => (
  <Edit {...props}>
    <SimpleForm redirect={false} toolbar={<Toolbar alwaysEnableSaveButton />}>
      <TextInput source="id" />
      <TextInput source="firstName" />
      <TextInput source="lastName" />
      <TextInput source="phone" />
      <TextInput source="email" />
      <BooleanInput source="isPro" />
      <BooleanInput source="isAdmin" />
    </SimpleForm>
  </Edit>
);
